import React from 'react'

const ViewPayout = () => {
    return (
        <div>I am the view</div>
    )
}

export default ViewPayout
